module.exports = __webpack_public_path__ + "static/img/legend_xa_english_dark.d9a4ea4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/legend_xa_english_dark.png
// module id = dxDs
// module chunks = 94